<script lang="ts">
    import { fade } from "svelte/transition";
    
    export let show: boolean = false;
</script>

{#if show}
    <div class="loading-bar" transition:fade={{ duration: 200 }}>
        <div class="loading-bar-progress"></div>
    </div>
{/if}

<style>
    .loading-bar {
        @apply absolute top-0 left-0 right-0 h-0.5 bg-transparent z-50;
    }

    .loading-bar-progress {
        @apply h-full bg-pink-500 w-0 animate-pulse;
        animation: progress 2s ease-in-out infinite;
    }

    @keyframes progress {
        0% {
            @apply w-0 opacity-50;
        }
        50% {
            @apply w-[70%] opacity-100;
        }
        100% {
            @apply w-full opacity-50;
        }
    }
</style> 